import React from "react";
import { FiltersStub, ReviewsBStub } from "Layouts/Stubs";
import Block from "ComponentsUI/Block";
import { PaddingTop } from "ComponentsUI/Spacings";

export default class Stub extends React.Component {
	render() {
		return (
			<PaddingTop>
				<Block stub={true}>
					<ReviewsBStub amount={3} />
				</Block>
			</PaddingTop>
		);
	}
}
